<template>
  <div class="result">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="top">
      <img src="@/assets/success.png" />
      <p class="top_text">下单成功</p>
    </div>
    <van-button
      type="danger"
      class="btn"
      @click="handleQueryOrder"
      v-if="configInfo.orderPlacedSuccessInfo === '1'"
      >查看订单</van-button
    >
    <div v-if="configInfo.orderPlacedSuccessInfo === '2'">
      客服电话：{{ "15753006610" }}
    </div>
    <img :src="configInfo.imageUrl" @click="handleLink" />
  </div>
</template>

<script>
export default {
  name: "orderSuccess",
  data() {
    return {
      type: "result",
      title: "订单信息",
      configInfo: {},
    };
  },
  created() {
    console.log("参数", this.$route.query);
    // const data = `{"imageLink":"https://www.baidu.com","imageUrl":"http://192.168.5.167:9000/blink-zehao/681896066238318929/zh-goods/2025/10/01/50fd8723e44c42c29d60d2fc35c1699a.jpg","orderPlacedFailureJumpMoneyTree":"2","orderPlacedSuccessInfo":"1"}`;
    // this.configInfo = JSON.parse(data);
    if(this.$route.query && this.$route.query.data){
      this.configInfo = JSON.parse(this.$route.query.data);
    }
  },
  methods: {
    onClickLeft() {
      console.log('state', this.$store.state);
      console.log('this.$store.state.pathName', this.$store.state.pathName);
      this.$router.push({
        path: this.$store.state.pathName,
      });
    },
    // 订单查询
    handleQueryOrder(){
      this.$router.push({
        path: '/order'
      })
    },
    // 图片跳转链接
    handleLink() {
      if (this.configInfo && this.configInfo.imageLink) {
        window.location.href = this.configInfo.imageLink;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  text-align: center;
  /deep/ .van-nav-bar__text,
  /deep/ .van-nav-bar .van-icon {
    color: red;
  }
  .top {
    margin: 30px 0 20px;
    img {
      width: 66px;
      height: 66px;
    }
    .top_text {
      font-size: 18px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
  .btn {
    width: 160px;
    height: 38px;
    border-radius: 50px;
  }
  img {
    width: 80%;
    height: auto;
    margin-top: 20px;
    border-radius: 6px;
  }
}
</style>
